// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./font/Satisfy/Satisfy-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("font/Josefin_Sans/JosefinSans-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./img/home-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./img/home-bg-tab.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Satisfy";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "JosefinSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    format("truetype");
  font-weight: 400 800;
  font-style: normal;
}

:root {
  /* Colors (palette)*/
  --col-accent: #f5cb5c;
  --col-accent-shade: #feb80a;
  --col-pure-white: #ffffff;
  --col-white: #e8eddf;
  --col-light-grey: #cfdbd5;
  --col-dark-grey: #333533;
  --col-black: #242423;
  --col-pure-black: #000000;

  --accent-gradient: linear-gradient(
    var(--col-accent) 30%,
    var(--col-accent-shade)
  );

  /* Colors (background)*/
  --bg-col: var(--col-white);
  --bg-col-txt: var(--accent-gradient);
  --bg-col-txt-alt: var(--col-dark-grey);
  --bg-col-button: var(--col-accent);

  /* Colors (text/icons)*/
  --col-txt: var(--col-black);
  --col-txt-alt: var(--col-white);
  --col-p-home: var(--col-black);
  --col-h3-book-now: var(--col-pure-white);
  --col-h2-tab: var(--col-black);
  --col-h3: var(--col-black);
  --col-h3-alt: var(--col-white);
  --col-h4: var(--col-dark-grey);
  --col-h4-alt: var(--col-accent);

  /* Font family */
  --main-font: "JosefinSans", sans-serif;
  --main-font-alt: "Satisfy", serif;
  --title-font: var(--main-font-alt);
  --button-font: var(--main-font-alt);

  /* Font sizes */
  --txt-fontsize: max(18px, 0.6vw);
  --txt-lineheight: 1.2;
  --title-font-size: 2.5rem;
  --home-h2-fontsize: min(4vw, 2rem);
  --home-txt-fontsize: min(6vw, 3rem);
  --tab-h2-fontsize: 2.5rem;
  --tab-h3-fontsize: 2rem;
  --tab-h3-menu-fontsize: 2.8rem;
  --tab-h4-fontsize: 2rem;
  --tab-p-fontsize: 1rem;
  --tab-price-fontsize: 1.2rem;
  --button-font-size: 1.5rem;
  --book-now-font-size: 1rem;

  --logo-size: calc(2 * var(--title-font-size));

  /* Maximum width (including dashboard margin) */
  --max-width: min(1440px, 100%);

  /*Margins, gaps and paddings (+widths)*/
  --home-button-tb-margin: 10vh;
  --home-padding: calc(max(0.5em, 5vh)) 1em;
  --header-padding: 1rem;
  --header-gap: 1rem;
  --footer-padding: 3rem 2rem;
  --footer-gap: 2rem;
  --tab-header-padding: 1rem 1rem 2rem;
  --tab-section-padding: 3.5rem 2rem;
  --tab-section-gap: 2rem;
  --tab-div-inside-section-gap: 1rem 2rem;
  --tab-div-inside-section-with-subsections-gap: 2rem 2rem;
  --tab-div-inside-subsections-gap: 0.5rem 0.5rem;
  --tab-section-empty-space: 55vh;
  --tab-price-padding: 0.3em 0.5em;
  --nav-gap: 1.5em;
  --nav-btn-sel-scale: 1.2;
  --contact-hours-horizontal-gap: 3rem;
  --book-now-max-width: 40em;
  --book-now-input-div-gap: 1.5em 2em;
  --book-now-input-padding: 0.5em 1em;
  --button-padding: 0.2em 1.2em;

  /* Radius */
  --radius: 4rem;
  --sel-radius: 50% 50% 78% 22% / 30% 49% 51% 70%;
  --map-radius: 1rem;
  --book-now-input-radius: 1rem;
  --button-radius: calc(var(--book-now-max-width) / 2);

  /* Shadows */
  --col-p-home: var(--col-dark-grey);
  --text-shadow: 3px 3px 3px var(--col-light-grey);
  --box-shadow-large: 0px 0px 20px 3px var(--col-dark-grey);
  --box-shadow-small: 0px 0px 4px 2px var(--col-pure-black);
  --box-shadow-inset-top: 0px 15px 15px -15px var(--col-dark-grey) inset;
  --box-shadow-double: var(--box-shadow-small), var(--box-shadow-large);

  /* Animations on hover / active / ...*/
  /* --transition-time: 0.8s; */
}

html {
  background-color: var(--bg-col);
  color: var(--col-txt);
  font-family: var(--main-font), sans-serif;
  font-weight: 400;
  font-size: var(--txt-fontsize);
  line-height: var(--txt-lineheight);
}

*,
*:before,
*:after {
  font-family: inherit;
  font-size: inherit; /* 100% */
  line-height: inherit;
  color: inherit;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  vertical-align: baseline;
}

body {
  margin: 0 auto;

  /* if you want to allow scroll: */
  min-height: 100vh;
  height: 100%;

  width: 100%;
  /* or max-width -- this avoids horizontal scroll bars */

  touch-action: manipulation; /* disable double tap to zoom on some browsers*/

  display: flex;
  flex-direction: column;
  align-items: center;
}

body > * {
  width: 100%;
}

.screen-height {
  min-height: 100vh;
  min-height: 100dvh; /* if supported */

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  display: flex;
  flex-direction: column;
}

.screen-height:has(.tab) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

h1,
h2,
h3,
h4,
p {
  text-wrap: balance;
}

p {
  text-wrap: wrap;
  text-wrap: pretty; /* if supported */
}

ul {
  list-style: none;
}

a,
a:hover,
a:active,
a:visited {
  text-decoration: none;
}

/* Button style might be overwritten */
button.styled {
  background-color: var(--bg-col-button);
  border: none;
  font-family: var(--button-font);
  font-size: var(--button-font-size);
  font-weight: 800;
  border-radius: var(--button-radius);
  padding: var(--button-padding);
  box-shadow: var(--box-shadow-small);
  width: max-content;
  background: var(--accent-gradient);
}

button.styled:active {
  filter: brightness(0.7);
}

@media not all and (hover: none) {
  button.styled:hover {
    filter: brightness(0.7);
  }
}

/* LOGO */
.logo-and-name {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo-and-name .name {
  font-family: var(--title-font);
  font-size: var(--title-font-size);
}
.logo-and-name img {
  width: var(--logo-size);
}

/* HEADER */

.screen-height > header {
  width: 100%;
  max-width: var(--max-width);
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: var(--header-padding);
  gap: var(--header-gap);
}

.screen-height > header nav {
  display: flex;
  gap: var(--nav-gap);
}
.screen-height > header nav button {
  text-transform: uppercase;
  background-color: transparent;
  border: none;
  font-weight: 800;
}

.screen-height:has(.home) > header .logo-and-name {
  pointer-events: none;
}
.screen-height:has(.tab.about) > header nav button.about-btn,
.screen-height:has(.tab.menu) > header nav button.menu-btn,
.screen-height:has(.tab.contact) > header nav button.contact-btn {
  transform: scale(var(--nav-btn-sel-scale));
  pointer-events: none;
  background: var(--accent-gradient);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

/* tablet or larger, or landscape (vs portrait)*/
@media only screen and (min-width: 768px), (orientation: landscape) {
  .screen-height > header {
    flex-direction: row;
  }

  .logo-and-name {
    flex-direction: row;
  }
}

/* when hover is supported */
@media not all and (hover: none) {
  .logo-and-name:hover {
    text-shadow: 2px 2px 2px var(--col-accent);
    cursor: pointer;
  }

  .screen-height > header nav button:hover {
    cursor: pointer;
    background: var(--accent-gradient);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
}

/* CONTENT */
#content {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
}

/* HOME PAGE */
#content.home {
  justify-content: space-evenly;
}

#content.home .home-txt {
  color: var(--col-p-home);
  font-size: var(--home-txt-fontsize);
  text-shadow: var(--text-shadow);
  padding: var(--home-padding);
  width: 100%;
  text-align: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  box-shadow: var(--box-shadow-large);
}

#content.home .home-txt h2 {
  font-size: var(--home-h2-fontsize);
  text-transform: uppercase;
  text-shadow: none;
  background: var(--accent-gradient);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

#content.home .highlight {
  font-family: var(--main-font-alt);
}

#content.home button {
  margin: var(--home-button-tb-margin) auto;
}

/* TAB PAGES */

#content:has(.tab) {
  justify-content: flex-start;
}

#content.tab section:nth-child(2n) {
  --section-bg-col-txt: var(--bg-col-txt-alt);
  --section-col-h3: var(--col-h4-alt);
  --section-col-h4: var(--col-h4-alt);
  --section-col-txt: var(--col-txt-alt);
  --section-bg-col-alt: var(--bg-col-txt);
  --section-col-txt-alt: var(--col-txt);
}
#content.tab section:nth-child(2n + 1) {
  --section-bg-col-txt: var(--bg-col-txt);
  --section-col-h3: var(--col-h4);
  --section-col-h4: var(--col-h4);
  --section-col-txt: var(--col-txt);
  --section-bg-col-alt: var(--bg-col-txt-alt);
  --section-col-txt-alt: var(--col-txt-alt);
}
#content.tab section.has-subsections:nth-child(2n) {
  --section-col-h3: var(--col-h3-alt);
}
#content.tab section.has-subsections:nth-child(2n + 1) {
  --section-col-h3: var(--col-h3);
}

#content.tab header {
  padding: var(--tab-header-padding);
}
#content.tab h2 {
  font-size: var(--tab-h2-fontsize);
  text-transform: uppercase;
  color: var(--col-h2-tab);
  font-weight: 800;
}

#content.tab section {
  background-color: transparent;
  width: 100%;
}

#content.tab section .section-container {
  max-width: var(--max-width);
  margin: 0 auto;
}

#content.tab section.with-bg-image,
#content.tab section:not(.with-bg-image) .section-container {
  box-shadow: var(--box-shadow-double);
}

#content.tab section:not(.with-bg-image).img-fixed .img-side {
  box-shadow: var(--box-shadow-inset-top);
}

#content.tab section:not(.with-bg-image) .section-container,
#content.tab section:not(.with-bg-image) .txt-side {
  background: var(--section-bg-col-txt);
}

#content.tab section .txt-side,
#content.tab section .txt-side > div,
#content.tab section .txt-side > div > div {
  display: flex;
  flex-direction: column;
}

#content.tab section .txt-side {
  padding: var(--tab-section-padding);
  gap: var(--tab-section-gap);
}

#content.tab section .txt-side > div {
  gap: var(--tab-div-inside-section-gap);
}

#content.tab section.has-subsections .txt-side > div {
  gap: var(--tab-div-inside-section-with-subsections-gap);
}

#content.tab section .txt-side > div > div {
  gap: var(--tab-div-inside-subsections-gap);
}

#content.tab section h3 {
  font-family: var(--main-font-alt);
  font-size: var(--tab-h3-fontsize);
  color: var(--section-col-h3);
}
#content.tab section.has-subsections h3 {
  font-size: var(--tab-h3-menu-fontsize);
  font-variant: small-caps;
  font-family: var(--main-font);
  text-align: center;
}
#content.tab section h4 {
  font-family: var(--main-font-alt);
  font-size: var(--tab-h4-fontsize);
  color: var(--section-col-h4);
}
#content.tab section p {
  font-size: var(--tab-p-fontsize);
  color: var(--section-col-txt);
}

#content.tab section.with-bg-image,
#content.tab section .img-side {
  min-height: 100%;
  max-height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

#content.tab section.with-bg-image.img-fixed,
#content.tab section.with-side-image.img-fixed .img-side {
  background-attachment: fixed;
}

#content.tab section.with-side-image .img-side {
  min-height: var(--tab-section-empty-space);
}

#content.tab section.with-side-image.img-alternate .section-container {
  display: grid;
  grid-template-areas:
    "img"
    "txt";
  grid-template-columns: 1fr;
  grid-template-rows: min-content min-content;
  --txt-side-width: 1fr; /* used in the next media query */
  --img-side-width: 1.2fr; /* used in the next media query */
}

@media only screen and (min-width: 768px), (orientation: landscape) {
  #content.tab section.with-side-image.img-alternate .section-container {
    grid-template-rows: max-content;
  }

  #content.tab
    section.with-side-image.img-alternate.img-first:nth-child(2n + 1)
    .section-container,
  #content.tab
    section.with-side-image.img-alternate:nth-child(2n)
    .section-container {
    grid-template-areas: "txt img";
    grid-template-columns: var(--txt-side-width) var(--img-side-width);
  }

  #content.tab
    section.with-side-image.img-alternate:nth-child(2n + 1)
    .section-container,
  #content.tab
    section.with-side-image.img-alternate.img-first:nth-child(2n)
    .section-container {
    grid-template-areas: "img txt";
    grid-template-columns: var(--img-side-width) var(--txt-side-width);
  }

  #content.tab section.with-side-image:not(.img-fixed) .img-side {
    min-height: auto;
  }
}

#content.tab section.with-side-image.img-alternate .txt-side {
  grid-area: txt;
}
#content.tab section.with-side-image.img-alternate .img-side {
  grid-area: img;
}

/* rules specific to menu tab */

#content.tab.menu section .dish {
  display: grid;
  justify-content: space-between;
  align-items: center;
  grid-template-areas:
    "h4 price"
    "p p";
  grid-template-columns: 1fr max-content;
}
#content.tab.menu .dish h4 {
  grid-area: h4;
}
#content.tab.menu .dish .price {
  border-radius: var(--sel-radius);
  padding: var(--tab-price-padding);
  font-size: var(--tab-price-fontsize);
  background: var(--section-bg-col-alt);
  color: var(--section-col-txt-alt);
  grid-area: price;
}
#content.tab.menu .dish p {
  grid-area: p;
  justify-self: left;
}

/* rules specific to contact tab */

#content.tab.contact section.with-side-image.img-alternate .section-container {
  --txt-side-width: minmax(max-content, 1fr);
}

#content.tab.contact section.with-side-image.img-alternate .txt-side {
  width: 100%;
}
#content.tab.contact section.with-side-image.img-alternate .txt-side > * {
  max-width: max-content;
  margin: 0 auto;
}

#content.tab.contact div.days-and-hours {
  display: grid;
  justify-content: space-between;
  grid-template-columns: max-content max-content;
}

#content.tab.contact .txt-side .days {
  color: var(--section-col-h4);
  font-variant: small-caps;
  text-transform: lowercase;
  font-weight: bold;
}

#content.tab.contact .txt-side .hours {
  display: flex;
  flex-direction: column;
  gap: 0px var(--contact-hours-horizontal-gap);
}

#content.tab.contact .txt-side .hour {
  width: max-content;
}

@media only screen and (min-width: 1024px) {
  #content.tab.contact .txt-side .hours {
    flex-direction: row;
  }
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 1em;
}

.contact-info > .contact-list > * {
  display: grid;
  grid-template-columns: max-content 1fr;
  text-wrap: balance;
  gap: 0.5em;
}

/* Purposely exclude .address from here to better centering .contact-info */
.contact-info .phone,
.contact-info .email {
  width: max-content;
}

.contact-info > .contact-social {
  display: flex !important;
  flex-direction: row !important;
  justify-content: center;
  gap: 1em !important;
  color: var(--col-txt);
}

@media not all and (hover: none) {
  .contact-info > .contact-social a:hover {
    color: var(--col-accent);
    cursor: pointer;
  }
}

svg.svg-inline--fa {
  vertical-align: top;
  color: var(--section-col-h3);
}

/* See https://blog.duda.co/responsive-google-maps-for-your-website */
#content.tab section .txt-side > .location-map {
  overflow: hidden;
  border-radius: var(--map-radius);
  display: initial !important;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
  flex: 1;
  min-width: 100%;
}

#content.tab section .txt-side > .location-map iframe {
  display: initial !important;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}

/* BOOK NOW tab */

#content.tab.book-now h2 {
  display: none;
}

#content.tab.book-now h3 {
  color: var(--col-h3-book-now);
  text-align: center;
}

#content.tab.book-now section .section-container {
  backdrop-filter: blur(2px) brightness(70%);
  max-width: 100%;
}

#content.tab.book-now button {
  grid-area: button;
  justify-self: center;
}

#content.tab.book-now form {
  display: grid;
  grid-template-areas:
    "name"
    "guests"
    "date"
    "hour"
    "email"
    "phone"
    "note"
    "."
    "button";
  grid-template-columns: 1fr;
  grid-template-columns: auto;
  gap: var(--book-now-input-div-gap);
  max-width: var(--book-now-max-width);
  width: 100%;
  margin: 0 auto;
}

@media only screen and (min-width: 768px), (orientation: landscape) {
  #content.tab.book-now form {
    grid-template-areas:
      "name name name name"
      "date date hour guests"
      "phone phone email email"
      "note note note note"
      ". . . ."
      ". button button .";
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}

#content.tab.book-now form .name-input-div {
  grid-area: name;
}
#content.tab.book-now form .guests-input-div {
  grid-area: guests;
}
#content.tab.book-now form .date-input-div {
  grid-area: date;
}
#content.tab.book-now form .hour-input-div {
  grid-area: hour;
}
#content.tab.book-now form .phone-input-div {
  grid-area: phone;
}
#content.tab.book-now form .email-input-div {
  grid-area: email;
}
#content.tab.book-now form .note-input-div {
  grid-area: note;
}

#content.tab.book-now form > div {
  display: flex;
  flex-direction: column;
}

#content.tab.book-now form input,
#content.tab.book-now form textarea {
  border-radius: var(--book-now-input-radius);
  border: none;
  outline: none;
}

#content.tab.book-now form label,
#content.tab.book-now form input,
#content.tab.book-now form textarea {
  padding: var(--book-now-input-padding);
  font-size: var(--book-now-font-size);
}

#content.tab.book-now form label {
  padding-top: 0;
  color: var(--col-txt-alt);
}

#content.tab.book-now form label:has(+ input:optional)::after,
#content.tab.book-now form label:has(+ textarea:optional)::after {
  content: " (optional)";
  font-style: italic;
  color: var(--col-light-grey);
}

/* FOOTER */
:root {
  --footer-days-and-hours-padding: 1rem;
}

footer.main-footer {
  width: 100%;
  max-width: var(--max-width);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: var(--footer-padding);
  gap: var(--footer-padding);
}

footer.main-footer .footer-content {
  display: grid;
  grid-template-areas:
    "logo"
    "info"
    "hours";
  grid-template-columns: min-content;
  justify-content: center;
  justify-items: center;
  gap: var(--footer-gap);
}

footer.main-footer .logo-and-name {
  grid-area: logo;
  flex-direction: column;
}
footer.main-footer .contact-info {
  grid-area: info;
  align-self: center;
}

footer.main-footer .days-and-hours {
  grid-area: hours;
  display: grid;
  grid-template-columns: max-content;
  border-top: 1px solid var(--col-txt);
  justify-content: center;
  justify-items: center;
  padding: var(--footer-days-and-hours-padding);
  padding-bottom: 0;
}
footer.main-footer .days-and-hours .days {
  font-weight: bold;
}
footer.main-footer .days-and-hours .days:not(:first-child) {
  margin-top: var(--footer-days-and-hours-padding);
}
footer.main-footer .days-and-hours .hours {
  display: flex;
}

footer.main-footer .days-and-hours .hour:not(:last-child):after {
  content: ",\\00a0";
}

footer.main-footer .img-credit {
  grid-area: "img-credit";
  text-align: justify;
  text-justify: inter-word;
  text-wrap: pretty;
}

footer.main-footer .img-credit a {
  font-weight: bold;
}

@media not all and (hover: none) {
  footer.main-footer .img-credit a:hover {
    text-shadow: 2px 2px 2px var(--col-accent);
    cursor: pointer;
  }
}

@media only screen and (min-width: 768px), (orientation: landscape) {
  footer.main-footer .footer-content {
    grid-template-areas:
      "logo info"
      "hours hours";
    grid-template-columns: max-content max-content;
  }

  footer.main-footer .days-and-hours {
    grid-template-columns: max-content max-content;
    justify-items: start;
    gap: 0 var(--footer-days-and-hours-padding);
  }

  footer.main-footer .days-and-hours .days:not(:first-child) {
    margin-top: 0;
  }
}

@media only screen and (min-width: 1024px) {
  footer.main-footer .footer-content {
    grid-template-areas: "logo info hours";
    grid-template-columns: max-content max-content max-content;
  }

  footer.main-footer .days-and-hours {
    align-self: center;
    border: none;
    border-left: 1px solid var(--col-txt);
    padding: var(--footer-days-and-hours-padding);
    padding-right: 0;
  }

  footer.main-footer .days-and-hours .days:not(:first-child) {
    margin-top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,+DAAiE;EACjE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B;sBACoB;EACpB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,yBAAyB;;EAEzB;;;GAGC;;EAED,uBAAuB;EACvB,0BAA0B;EAC1B,oCAAoC;EACpC,sCAAsC;EACtC,kCAAkC;;EAElC,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,wCAAwC;EACxC,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;;EAE/B,gBAAgB;EAChB,sCAAsC;EACtC,iCAAiC;EACjC,kCAAkC;EAClC,mCAAmC;;EAEnC,eAAe;EACf,gCAAgC;EAChC,qBAAqB;EACrB,yBAAyB;EACzB,kCAAkC;EAClC,mCAAmC;EACnC,yBAAyB;EACzB,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;;EAE1B,6CAA6C;;EAE7C,+CAA+C;EAC/C,8BAA8B;;EAE9B,uCAAuC;EACvC,6BAA6B;EAC7B,yCAAyC;EACzC,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,oCAAoC;EACpC,kCAAkC;EAClC,uBAAuB;EACvB,uCAAuC;EACvC,wDAAwD;EACxD,+CAA+C;EAC/C,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,wBAAwB;EACxB,oCAAoC;EACpC,0BAA0B;EAC1B,mCAAmC;EACnC,mCAAmC;EACnC,6BAA6B;;EAE7B,WAAW;EACX,cAAc;EACd,+CAA+C;EAC/C,kBAAkB;EAClB,6BAA6B;EAC7B,oDAAoD;;EAEpD,YAAY;EACZ,kCAAkC;EAClC,gDAAgD;EAChD,yDAAyD;EACzD,yDAAyD;EACzD,sEAAsE;EACtE,qEAAqE;;EAErE,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,yCAAyC;EACzC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;;;EAGE,oBAAoB;EACpB,kBAAkB,EAAE,SAAS;EAC7B,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,cAAc;;EAEd,iCAAiC;EACjC,iBAAiB;EACjB,YAAY;;EAEZ,WAAW;EACX,uDAAuD;;EAEvD,0BAA0B,EAAE,+CAA+C;;EAE3E,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB,EAAE,iBAAiB;;EAErC,yDAA0C;EAC1C,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yDAA8C;AAChD;;AAEA;;;;;EAKE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB,EAAE,iBAAiB;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,sCAAsC;EACtC,YAAY;EACZ,+BAA+B;EAC/B,kCAAkC;EAClC,gBAAgB;EAChB,mCAAmC;EACnC,8BAA8B;EAC9B,mCAAmC;EACnC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,uBAAuB;AACzB;;AAEA,WAAW;;AAEX;EACE,WAAW;EACX,2BAA2B;EAC3B,cAAc;;EAEd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;AACA;;;EAGE,0CAA0C;EAC1C,oBAAoB;EACpB,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,0CAA0C;IAC1C,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kCAAkC;IAClC,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;EACpB;AACF;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;AACT;;AAEA,cAAc;AACd;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,yDAA8C;EAC9C,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,iBAAiB;EACjB,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,cAAc;;AAEd;EACE,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,mCAAmC;EACnC,mCAAmC;EACnC,qCAAqC;EACrC,uCAAuC;EACvC,qCAAqC;AACvC;AACA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,+BAA+B;EAC/B,iCAAiC;EACjC,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,mCAAmC;AACrC;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb;;SAEO;EACP,0BAA0B;EAC1B,2CAA2C;EAC3C,qBAAqB,EAAE,iCAAiC;EACxD,uBAAuB,EAAE,iCAAiC;AAC5D;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;;;;;;IAME,8BAA8B;IAC9B,kEAAkE;EACpE;;EAEA;;;;;;IAME,8BAA8B;IAC9B,kEAAkE;EACpE;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,+BAA+B;;AAE/B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB;;SAEO;EACP,sCAAsC;AACxC;AACA;EACE,aAAa;AACf;AACA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,oCAAoC;EACpC,qCAAqC;EACrC,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,kCAAkC;;AAElC;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,UAAU;AACZ;;AAEA,2EAA2E;AAC3E;;EAEE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,wBAAwB;IACxB,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,qEAAqE;AACrE;EACE,gBAAgB;EAChB,gCAAgC;EAChC,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA,iBAAiB;;AAEjB;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb;;;;;;;;;YASU;EACV,0BAA0B;EAC1B,2BAA2B;EAC3B,kCAAkC;EAClC,oCAAoC;EACpC,WAAW;EACX,cAAc;AAChB;;AAEA;EACE;IACE;;;;;;yBAMqB;IACrB,sCAAsC;EACxC;AACF;;AAEA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,2CAA2C;EAC3C,YAAY;EACZ,aAAa;AACf;;AAEA;;;EAGE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,WAAW;AACX;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb;;;WAGS;EACT,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,oCAAoC;EACpC,uBAAuB;EACvB,qBAAqB;EACrB,6CAA6C;EAC7C,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gDAAgD;AAClD;AACA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,0CAA0C;IAC1C,eAAe;EACjB;AACF;;AAEA;EACE;IACE;;mBAEe;IACf,8CAA8C;EAChD;;EAEA;IACE,8CAA8C;IAC9C,oBAAoB;IACpB,2CAA2C;EAC7C;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,0DAA0D;EAC5D;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,qCAAqC;IACrC,6CAA6C;IAC7C,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["@font-face {\n  font-family: \"Satisfy\";\n  src: url(\"./font/Satisfy/Satisfy-Regular.ttf\") format(\"truetype\");\n  font-weight: 400;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"JosefinSans\";\n  src: url(\"font/Josefin_Sans/JosefinSans-VariableFont_wght.ttf\")\n    format(\"truetype\");\n  font-weight: 400 800;\n  font-style: normal;\n}\n\n:root {\n  /* Colors (palette)*/\n  --col-accent: #f5cb5c;\n  --col-accent-shade: #feb80a;\n  --col-pure-white: #ffffff;\n  --col-white: #e8eddf;\n  --col-light-grey: #cfdbd5;\n  --col-dark-grey: #333533;\n  --col-black: #242423;\n  --col-pure-black: #000000;\n\n  --accent-gradient: linear-gradient(\n    var(--col-accent) 30%,\n    var(--col-accent-shade)\n  );\n\n  /* Colors (background)*/\n  --bg-col: var(--col-white);\n  --bg-col-txt: var(--accent-gradient);\n  --bg-col-txt-alt: var(--col-dark-grey);\n  --bg-col-button: var(--col-accent);\n\n  /* Colors (text/icons)*/\n  --col-txt: var(--col-black);\n  --col-txt-alt: var(--col-white);\n  --col-p-home: var(--col-black);\n  --col-h3-book-now: var(--col-pure-white);\n  --col-h2-tab: var(--col-black);\n  --col-h3: var(--col-black);\n  --col-h3-alt: var(--col-white);\n  --col-h4: var(--col-dark-grey);\n  --col-h4-alt: var(--col-accent);\n\n  /* Font family */\n  --main-font: \"JosefinSans\", sans-serif;\n  --main-font-alt: \"Satisfy\", serif;\n  --title-font: var(--main-font-alt);\n  --button-font: var(--main-font-alt);\n\n  /* Font sizes */\n  --txt-fontsize: max(18px, 0.6vw);\n  --txt-lineheight: 1.2;\n  --title-font-size: 2.5rem;\n  --home-h2-fontsize: min(4vw, 2rem);\n  --home-txt-fontsize: min(6vw, 3rem);\n  --tab-h2-fontsize: 2.5rem;\n  --tab-h3-fontsize: 2rem;\n  --tab-h3-menu-fontsize: 2.8rem;\n  --tab-h4-fontsize: 2rem;\n  --tab-p-fontsize: 1rem;\n  --tab-price-fontsize: 1.2rem;\n  --button-font-size: 1.5rem;\n  --book-now-font-size: 1rem;\n\n  --logo-size: calc(2 * var(--title-font-size));\n\n  /* Maximum width (including dashboard margin) */\n  --max-width: min(1440px, 100%);\n\n  /*Margins, gaps and paddings (+widths)*/\n  --home-button-tb-margin: 10vh;\n  --home-padding: calc(max(0.5em, 5vh)) 1em;\n  --header-padding: 1rem;\n  --header-gap: 1rem;\n  --footer-padding: 3rem 2rem;\n  --footer-gap: 2rem;\n  --tab-header-padding: 1rem 1rem 2rem;\n  --tab-section-padding: 3.5rem 2rem;\n  --tab-section-gap: 2rem;\n  --tab-div-inside-section-gap: 1rem 2rem;\n  --tab-div-inside-section-with-subsections-gap: 2rem 2rem;\n  --tab-div-inside-subsections-gap: 0.5rem 0.5rem;\n  --tab-section-empty-space: 55vh;\n  --tab-price-padding: 0.3em 0.5em;\n  --nav-gap: 1.5em;\n  --nav-btn-sel-scale: 1.2;\n  --contact-hours-horizontal-gap: 3rem;\n  --book-now-max-width: 40em;\n  --book-now-input-div-gap: 1.5em 2em;\n  --book-now-input-padding: 0.5em 1em;\n  --button-padding: 0.2em 1.2em;\n\n  /* Radius */\n  --radius: 4rem;\n  --sel-radius: 50% 50% 78% 22% / 30% 49% 51% 70%;\n  --map-radius: 1rem;\n  --book-now-input-radius: 1rem;\n  --button-radius: calc(var(--book-now-max-width) / 2);\n\n  /* Shadows */\n  --col-p-home: var(--col-dark-grey);\n  --text-shadow: 3px 3px 3px var(--col-light-grey);\n  --box-shadow-large: 0px 0px 20px 3px var(--col-dark-grey);\n  --box-shadow-small: 0px 0px 4px 2px var(--col-pure-black);\n  --box-shadow-inset-top: 0px 15px 15px -15px var(--col-dark-grey) inset;\n  --box-shadow-double: var(--box-shadow-small), var(--box-shadow-large);\n\n  /* Animations on hover / active / ...*/\n  /* --transition-time: 0.8s; */\n}\n\nhtml {\n  background-color: var(--bg-col);\n  color: var(--col-txt);\n  font-family: var(--main-font), sans-serif;\n  font-weight: 400;\n  font-size: var(--txt-fontsize);\n  line-height: var(--txt-lineheight);\n}\n\n*,\n*:before,\n*:after {\n  font-family: inherit;\n  font-size: inherit; /* 100% */\n  line-height: inherit;\n  color: inherit;\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n  vertical-align: baseline;\n}\n\nbody {\n  margin: 0 auto;\n\n  /* if you want to allow scroll: */\n  min-height: 100vh;\n  height: 100%;\n\n  width: 100%;\n  /* or max-width -- this avoids horizontal scroll bars */\n\n  touch-action: manipulation; /* disable double tap to zoom on some browsers*/\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\nbody > * {\n  width: 100%;\n}\n\n.screen-height {\n  min-height: 100vh;\n  min-height: 100dvh; /* if supported */\n\n  background-image: url(\"./img/home-bg.jpg\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  background-attachment: fixed;\n  display: flex;\n  flex-direction: column;\n}\n\n.screen-height:has(.tab) {\n  background-image: url(\"./img/home-bg-tab.jpg\");\n}\n\nh1,\nh2,\nh3,\nh4,\np {\n  text-wrap: balance;\n}\n\np {\n  text-wrap: wrap;\n  text-wrap: pretty; /* if supported */\n}\n\nul {\n  list-style: none;\n}\n\na,\na:hover,\na:active,\na:visited {\n  text-decoration: none;\n}\n\n/* Button style might be overwritten */\nbutton.styled {\n  background-color: var(--bg-col-button);\n  border: none;\n  font-family: var(--button-font);\n  font-size: var(--button-font-size);\n  font-weight: 800;\n  border-radius: var(--button-radius);\n  padding: var(--button-padding);\n  box-shadow: var(--box-shadow-small);\n  width: max-content;\n  background: var(--accent-gradient);\n}\n\nbutton.styled:active {\n  filter: brightness(0.7);\n}\n\n@media not all and (hover: none) {\n  button.styled:hover {\n    filter: brightness(0.7);\n  }\n}\n\n/* LOGO */\n.logo-and-name {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.logo-and-name .name {\n  font-family: var(--title-font);\n  font-size: var(--title-font-size);\n}\n.logo-and-name img {\n  width: var(--logo-size);\n}\n\n/* HEADER */\n\n.screen-height > header {\n  width: 100%;\n  max-width: var(--max-width);\n  margin: 0 auto;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--header-padding);\n  gap: var(--header-gap);\n}\n\n.screen-height > header nav {\n  display: flex;\n  gap: var(--nav-gap);\n}\n.screen-height > header nav button {\n  text-transform: uppercase;\n  background-color: transparent;\n  border: none;\n  font-weight: 800;\n}\n\n.screen-height:has(.home) > header .logo-and-name {\n  pointer-events: none;\n}\n.screen-height:has(.tab.about) > header nav button.about-btn,\n.screen-height:has(.tab.menu) > header nav button.menu-btn,\n.screen-height:has(.tab.contact) > header nav button.contact-btn {\n  transform: scale(var(--nav-btn-sel-scale));\n  pointer-events: none;\n  background: var(--accent-gradient);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n/* tablet or larger, or landscape (vs portrait)*/\n@media only screen and (min-width: 768px), (orientation: landscape) {\n  .screen-height > header {\n    flex-direction: row;\n  }\n\n  .logo-and-name {\n    flex-direction: row;\n  }\n}\n\n/* when hover is supported */\n@media not all and (hover: none) {\n  .logo-and-name:hover {\n    text-shadow: 2px 2px 2px var(--col-accent);\n    cursor: pointer;\n  }\n\n  .screen-height > header nav button:hover {\n    cursor: pointer;\n    background: var(--accent-gradient);\n    -webkit-background-clip: text;\n    background-clip: text;\n    color: transparent;\n  }\n}\n\n/* CONTENT */\n#content {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n\n/* HOME PAGE */\n#content.home {\n  justify-content: space-evenly;\n}\n\n#content.home .home-txt {\n  color: var(--col-p-home);\n  font-size: var(--home-txt-fontsize);\n  text-shadow: var(--text-shadow);\n  padding: var(--home-padding);\n  width: 100%;\n  text-align: center;\n  background-image: url(\"./img/home-bg-tab.jpg\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  background-attachment: fixed;\n  box-shadow: var(--box-shadow-large);\n}\n\n#content.home .home-txt h2 {\n  font-size: var(--home-h2-fontsize);\n  text-transform: uppercase;\n  text-shadow: none;\n  background: var(--accent-gradient);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n#content.home .highlight {\n  font-family: var(--main-font-alt);\n}\n\n#content.home button {\n  margin: var(--home-button-tb-margin) auto;\n}\n\n/* TAB PAGES */\n\n#content:has(.tab) {\n  justify-content: flex-start;\n}\n\n#content.tab section:nth-child(2n) {\n  --section-bg-col-txt: var(--bg-col-txt-alt);\n  --section-col-h3: var(--col-h4-alt);\n  --section-col-h4: var(--col-h4-alt);\n  --section-col-txt: var(--col-txt-alt);\n  --section-bg-col-alt: var(--bg-col-txt);\n  --section-col-txt-alt: var(--col-txt);\n}\n#content.tab section:nth-child(2n + 1) {\n  --section-bg-col-txt: var(--bg-col-txt);\n  --section-col-h3: var(--col-h4);\n  --section-col-h4: var(--col-h4);\n  --section-col-txt: var(--col-txt);\n  --section-bg-col-alt: var(--bg-col-txt-alt);\n  --section-col-txt-alt: var(--col-txt-alt);\n}\n#content.tab section.has-subsections:nth-child(2n) {\n  --section-col-h3: var(--col-h3-alt);\n}\n#content.tab section.has-subsections:nth-child(2n + 1) {\n  --section-col-h3: var(--col-h3);\n}\n\n#content.tab header {\n  padding: var(--tab-header-padding);\n}\n#content.tab h2 {\n  font-size: var(--tab-h2-fontsize);\n  text-transform: uppercase;\n  color: var(--col-h2-tab);\n  font-weight: 800;\n}\n\n#content.tab section {\n  background-color: transparent;\n  width: 100%;\n}\n\n#content.tab section .section-container {\n  max-width: var(--max-width);\n  margin: 0 auto;\n}\n\n#content.tab section.with-bg-image,\n#content.tab section:not(.with-bg-image) .section-container {\n  box-shadow: var(--box-shadow-double);\n}\n\n#content.tab section:not(.with-bg-image).img-fixed .img-side {\n  box-shadow: var(--box-shadow-inset-top);\n}\n\n#content.tab section:not(.with-bg-image) .section-container,\n#content.tab section:not(.with-bg-image) .txt-side {\n  background: var(--section-bg-col-txt);\n}\n\n#content.tab section .txt-side,\n#content.tab section .txt-side > div,\n#content.tab section .txt-side > div > div {\n  display: flex;\n  flex-direction: column;\n}\n\n#content.tab section .txt-side {\n  padding: var(--tab-section-padding);\n  gap: var(--tab-section-gap);\n}\n\n#content.tab section .txt-side > div {\n  gap: var(--tab-div-inside-section-gap);\n}\n\n#content.tab section.has-subsections .txt-side > div {\n  gap: var(--tab-div-inside-section-with-subsections-gap);\n}\n\n#content.tab section .txt-side > div > div {\n  gap: var(--tab-div-inside-subsections-gap);\n}\n\n#content.tab section h3 {\n  font-family: var(--main-font-alt);\n  font-size: var(--tab-h3-fontsize);\n  color: var(--section-col-h3);\n}\n#content.tab section.has-subsections h3 {\n  font-size: var(--tab-h3-menu-fontsize);\n  font-variant: small-caps;\n  font-family: var(--main-font);\n  text-align: center;\n}\n#content.tab section h4 {\n  font-family: var(--main-font-alt);\n  font-size: var(--tab-h4-fontsize);\n  color: var(--section-col-h4);\n}\n#content.tab section p {\n  font-size: var(--tab-p-fontsize);\n  color: var(--section-col-txt);\n}\n\n#content.tab section.with-bg-image,\n#content.tab section .img-side {\n  min-height: 100%;\n  max-height: 100%;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n#content.tab section.with-bg-image.img-fixed,\n#content.tab section.with-side-image.img-fixed .img-side {\n  background-attachment: fixed;\n}\n\n#content.tab section.with-side-image .img-side {\n  min-height: var(--tab-section-empty-space);\n}\n\n#content.tab section.with-side-image.img-alternate .section-container {\n  display: grid;\n  grid-template-areas:\n    \"img\"\n    \"txt\";\n  grid-template-columns: 1fr;\n  grid-template-rows: min-content min-content;\n  --txt-side-width: 1fr; /* used in the next media query */\n  --img-side-width: 1.2fr; /* used in the next media query */\n}\n\n@media only screen and (min-width: 768px), (orientation: landscape) {\n  #content.tab section.with-side-image.img-alternate .section-container {\n    grid-template-rows: max-content;\n  }\n\n  #content.tab\n    section.with-side-image.img-alternate.img-first:nth-child(2n + 1)\n    .section-container,\n  #content.tab\n    section.with-side-image.img-alternate:nth-child(2n)\n    .section-container {\n    grid-template-areas: \"txt img\";\n    grid-template-columns: var(--txt-side-width) var(--img-side-width);\n  }\n\n  #content.tab\n    section.with-side-image.img-alternate:nth-child(2n + 1)\n    .section-container,\n  #content.tab\n    section.with-side-image.img-alternate.img-first:nth-child(2n)\n    .section-container {\n    grid-template-areas: \"img txt\";\n    grid-template-columns: var(--img-side-width) var(--txt-side-width);\n  }\n\n  #content.tab section.with-side-image:not(.img-fixed) .img-side {\n    min-height: auto;\n  }\n}\n\n#content.tab section.with-side-image.img-alternate .txt-side {\n  grid-area: txt;\n}\n#content.tab section.with-side-image.img-alternate .img-side {\n  grid-area: img;\n}\n\n/* rules specific to menu tab */\n\n#content.tab.menu section .dish {\n  display: grid;\n  justify-content: space-between;\n  align-items: center;\n  grid-template-areas:\n    \"h4 price\"\n    \"p p\";\n  grid-template-columns: 1fr max-content;\n}\n#content.tab.menu .dish h4 {\n  grid-area: h4;\n}\n#content.tab.menu .dish .price {\n  border-radius: var(--sel-radius);\n  padding: var(--tab-price-padding);\n  font-size: var(--tab-price-fontsize);\n  background: var(--section-bg-col-alt);\n  color: var(--section-col-txt-alt);\n  grid-area: price;\n}\n#content.tab.menu .dish p {\n  grid-area: p;\n  justify-self: left;\n}\n\n/* rules specific to contact tab */\n\n#content.tab.contact section.with-side-image.img-alternate .section-container {\n  --txt-side-width: minmax(max-content, 1fr);\n}\n\n#content.tab.contact section.with-side-image.img-alternate .txt-side {\n  width: 100%;\n}\n#content.tab.contact section.with-side-image.img-alternate .txt-side > * {\n  max-width: max-content;\n  margin: 0 auto;\n}\n\n#content.tab.contact div.days-and-hours {\n  display: grid;\n  justify-content: space-between;\n  grid-template-columns: max-content max-content;\n}\n\n#content.tab.contact .txt-side .days {\n  color: var(--section-col-h4);\n  font-variant: small-caps;\n  text-transform: lowercase;\n  font-weight: bold;\n}\n\n#content.tab.contact .txt-side .hours {\n  display: flex;\n  flex-direction: column;\n  gap: 0px var(--contact-hours-horizontal-gap);\n}\n\n#content.tab.contact .txt-side .hour {\n  width: max-content;\n}\n\n@media only screen and (min-width: 1024px) {\n  #content.tab.contact .txt-side .hours {\n    flex-direction: row;\n  }\n}\n\n.contact-info {\n  display: flex;\n  flex-direction: column;\n  gap: 1em;\n}\n\n.contact-info > .contact-list > * {\n  display: grid;\n  grid-template-columns: max-content 1fr;\n  text-wrap: balance;\n  gap: 0.5em;\n}\n\n/* Purposely exclude .address from here to better centering .contact-info */\n.contact-info .phone,\n.contact-info .email {\n  width: max-content;\n}\n\n.contact-info > .contact-social {\n  display: flex !important;\n  flex-direction: row !important;\n  justify-content: center;\n  gap: 1em !important;\n  color: var(--col-txt);\n}\n\n@media not all and (hover: none) {\n  .contact-info > .contact-social a:hover {\n    color: var(--col-accent);\n    cursor: pointer;\n  }\n}\n\nsvg.svg-inline--fa {\n  vertical-align: top;\n  color: var(--section-col-h3);\n}\n\n/* See https://blog.duda.co/responsive-google-maps-for-your-website */\n#content.tab section .txt-side > .location-map {\n  overflow: hidden;\n  border-radius: var(--map-radius);\n  display: initial !important;\n  padding-bottom: 56.25%;\n  position: relative;\n  height: 0;\n  flex: 1;\n  min-width: 100%;\n}\n\n#content.tab section .txt-side > .location-map iframe {\n  display: initial !important;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n}\n\n/* BOOK NOW tab */\n\n#content.tab.book-now h2 {\n  display: none;\n}\n\n#content.tab.book-now h3 {\n  color: var(--col-h3-book-now);\n  text-align: center;\n}\n\n#content.tab.book-now section .section-container {\n  backdrop-filter: blur(2px) brightness(70%);\n  max-width: 100%;\n}\n\n#content.tab.book-now button {\n  grid-area: button;\n  justify-self: center;\n}\n\n#content.tab.book-now form {\n  display: grid;\n  grid-template-areas:\n    \"name\"\n    \"guests\"\n    \"date\"\n    \"hour\"\n    \"email\"\n    \"phone\"\n    \"note\"\n    \".\"\n    \"button\";\n  grid-template-columns: 1fr;\n  grid-template-columns: auto;\n  gap: var(--book-now-input-div-gap);\n  max-width: var(--book-now-max-width);\n  width: 100%;\n  margin: 0 auto;\n}\n\n@media only screen and (min-width: 768px), (orientation: landscape) {\n  #content.tab.book-now form {\n    grid-template-areas:\n      \"name name name name\"\n      \"date date hour guests\"\n      \"phone phone email email\"\n      \"note note note note\"\n      \". . . .\"\n      \". button button .\";\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n  }\n}\n\n#content.tab.book-now form .name-input-div {\n  grid-area: name;\n}\n#content.tab.book-now form .guests-input-div {\n  grid-area: guests;\n}\n#content.tab.book-now form .date-input-div {\n  grid-area: date;\n}\n#content.tab.book-now form .hour-input-div {\n  grid-area: hour;\n}\n#content.tab.book-now form .phone-input-div {\n  grid-area: phone;\n}\n#content.tab.book-now form .email-input-div {\n  grid-area: email;\n}\n#content.tab.book-now form .note-input-div {\n  grid-area: note;\n}\n\n#content.tab.book-now form > div {\n  display: flex;\n  flex-direction: column;\n}\n\n#content.tab.book-now form input,\n#content.tab.book-now form textarea {\n  border-radius: var(--book-now-input-radius);\n  border: none;\n  outline: none;\n}\n\n#content.tab.book-now form label,\n#content.tab.book-now form input,\n#content.tab.book-now form textarea {\n  padding: var(--book-now-input-padding);\n  font-size: var(--book-now-font-size);\n}\n\n#content.tab.book-now form label {\n  padding-top: 0;\n  color: var(--col-txt-alt);\n}\n\n#content.tab.book-now form label:has(+ input:optional)::after,\n#content.tab.book-now form label:has(+ textarea:optional)::after {\n  content: \" (optional)\";\n  font-style: italic;\n  color: var(--col-light-grey);\n}\n\n/* FOOTER */\n:root {\n  --footer-days-and-hours-padding: 1rem;\n}\n\nfooter.main-footer {\n  width: 100%;\n  max-width: var(--max-width);\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  padding: var(--footer-padding);\n  gap: var(--footer-padding);\n}\n\nfooter.main-footer .footer-content {\n  display: grid;\n  grid-template-areas:\n    \"logo\"\n    \"info\"\n    \"hours\";\n  grid-template-columns: min-content;\n  justify-content: center;\n  justify-items: center;\n  gap: var(--footer-gap);\n}\n\nfooter.main-footer .logo-and-name {\n  grid-area: logo;\n  flex-direction: column;\n}\nfooter.main-footer .contact-info {\n  grid-area: info;\n  align-self: center;\n}\n\nfooter.main-footer .days-and-hours {\n  grid-area: hours;\n  display: grid;\n  grid-template-columns: max-content;\n  border-top: 1px solid var(--col-txt);\n  justify-content: center;\n  justify-items: center;\n  padding: var(--footer-days-and-hours-padding);\n  padding-bottom: 0;\n}\nfooter.main-footer .days-and-hours .days {\n  font-weight: bold;\n}\nfooter.main-footer .days-and-hours .days:not(:first-child) {\n  margin-top: var(--footer-days-and-hours-padding);\n}\nfooter.main-footer .days-and-hours .hours {\n  display: flex;\n}\n\nfooter.main-footer .days-and-hours .hour:not(:last-child):after {\n  content: \",\\00a0\";\n}\n\nfooter.main-footer .img-credit {\n  grid-area: \"img-credit\";\n  text-align: justify;\n  text-justify: inter-word;\n  text-wrap: pretty;\n}\n\nfooter.main-footer .img-credit a {\n  font-weight: bold;\n}\n\n@media not all and (hover: none) {\n  footer.main-footer .img-credit a:hover {\n    text-shadow: 2px 2px 2px var(--col-accent);\n    cursor: pointer;\n  }\n}\n\n@media only screen and (min-width: 768px), (orientation: landscape) {\n  footer.main-footer .footer-content {\n    grid-template-areas:\n      \"logo info\"\n      \"hours hours\";\n    grid-template-columns: max-content max-content;\n  }\n\n  footer.main-footer .days-and-hours {\n    grid-template-columns: max-content max-content;\n    justify-items: start;\n    gap: 0 var(--footer-days-and-hours-padding);\n  }\n\n  footer.main-footer .days-and-hours .days:not(:first-child) {\n    margin-top: 0;\n  }\n}\n\n@media only screen and (min-width: 1024px) {\n  footer.main-footer .footer-content {\n    grid-template-areas: \"logo info hours\";\n    grid-template-columns: max-content max-content max-content;\n  }\n\n  footer.main-footer .days-and-hours {\n    align-self: center;\n    border: none;\n    border-left: 1px solid var(--col-txt);\n    padding: var(--footer-days-and-hours-padding);\n    padding-right: 0;\n  }\n\n  footer.main-footer .days-and-hours .days:not(:first-child) {\n    margin-top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
